import * as React from 'react';

import SubscriptionVPropCDP from 'bundles/enroll-modal/components/subscriptions/SubscriptionVPropCDP';
import SubscriptionVPropSDP from 'bundles/enroll-modal/components/subscriptions/SubscriptionVPropSDP';
import SubscriptionVPropBulletPointV2 from 'bundles/enroll-modal/components/subscriptions/free-trialV2/SubscriptionVPropBulletPoint';
import { getPaidSubscriptionBulletsV2 } from 'bundles/enroll-modal/components/subscriptions/free-trialV2/utils/bulletData';
import usePageData from 'bundles/enroll-modal/data/usePageData';
import ReactPriceDisplay from 'bundles/ownable-products-common/components/ReactPriceDisplay';

import 'css!./__styles__/SubscriptionVProp';

type PropsFromCaller = {
  onSdp: boolean;
};

const SubscriptionVProp = ({ onSdp }: PropsFromCaller) => {
  const { s12nDerivatives, s12nSubscriptionOwnableProduct, s12n } = usePageData();
  const s12nProductPrice = s12nSubscriptionOwnableProduct?.price || s12nDerivatives?.catalogPrice;

  if (!(s12n && s12nProductPrice)) {
    return null;
  }

  const bullets = getPaidSubscriptionBulletsV2({
    s12nProductVariant: s12n?.productVariant,
  });
  const monthlyPrice = <ReactPriceDisplay currency={s12nProductPrice.currencyCode} value={s12nProductPrice.amount} />;
  return (
    <div className="rc-SubscriptionVProp">
      <div className="punch-line">{onSdp ? <SubscriptionVPropSDP /> : <SubscriptionVPropCDP />}</div>
      <ul className="bullet_list nostyle">
        {bullets.map((bullet) => {
          return (
            <li key={`bullet_${bullet.header}`}>
              <SubscriptionVPropBulletPointV2 messageProps={{ monthlyPrice }} highlightHeader={true} {...bullet} />
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default SubscriptionVProp;
